import { FieldBase } from '@/components/form';
import { Toggle } from '@e2n/ui';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';

export function SollstundenToggle() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  return (
    <form.AppField
      name="bezahlung.arbeitszeitkonto.gehaltsempfaenger.sollstunden"
      listeners={{
        onChange() {
          ctx.resetDependentFields(
            'bezahlung.arbeitszeitkonto.gehaltsempfaenger.sollstunden',
          );
        },
      }}>
      {(field) => (
        <FieldBase>
          <div className="col-span-2 grid md:grid-cols-2 items-start gap-4">
            <Toggle
              pressed={field.state.value === true}
              onPressedChange={() => field.handleChange(true)}
              variant={'outline'}
              className="flex items-center justify-start gap-2 p-4 h-auto">
              {t(
                'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.sollstunden.options.ja',
              )}
            </Toggle>
            <Toggle
              pressed={field.state.value === false}
              onPressedChange={() => field.handleChange(false)}
              variant={'outline'}
              className="flex items-center justify-start gap-2 p-4 h-auto">
              {t(
                'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.sollstunden.options.nein',
              )}
            </Toggle>
          </div>
        </FieldBase>
      )}
    </form.AppField>
  );
}
